import Token from "./models/token";
import "./requests/magentaRequest";
import MagentaRestServices from "./services/magentaServices";
import TokenServices from "./services/tokenServices";

export class MagentaOauth {
  async login(username: string, password: string) {
    const response = await MagentaRestServices.login(username, password);

    if (response.status === 200) {
      const data = response.data;
      const token = new Token(
        data.access_token,
        data.refresh_token,
        data.scope,
        data.token_type,
        data.expires_in
      );

      TokenServices.setToken(token);
    }
    return response;
  }

  async logout() {
    const response = await MagentaRestServices.logout();
    if (response.status == 200) {
      TokenServices.clearToken();
    }
    return response;
  }

  async refreshToken() {
    const response = await MagentaRestServices.refreshToken();
    if (response.status === 200) {
      const data = response.data;
      const token = new Token(
        data.access_token,
        data.refresh_token,
        data.scope,
        data.token_type,
        data.expires_in
      );
      TokenServices.setToken(token);
    } else {
      TokenServices.clearToken();
      throw new Error(response.message || "Failed to refresh token");
    }
    return response;
  }

  async active() {
    const response = await TokenServices.isActive();
    return response;
  }

  async setPassword(data: {}) {
    const response = await MagentaRestServices.setPassword(data);
    return response
  }

  async changePassword(username: string) {
    const response = await MagentaRestServices.changePassword(username);
    return response
  }

  async requestWelcomeMail(data: {}) {
    const response = await MagentaRestServices.requestWelcomeMail(data);
    return response
  }

}

const magentaOauth = new MagentaOauth();

export default magentaOauth;
